import { Spinner as BaseSpinner } from '@chilecompra/react-kit/components'
import { Search as BaseSearchIcon } from '@mui/icons-material'
import { styled } from '@mui/material'

import { BaseContainer, BaseItem } from '../../configs/styles/BaseGrid'

export const Container = styled(BaseContainer)``

export const WrapperGrid = styled(BaseContainer)`
  &.MuiGrid-container {
    display: grid;
    grid-template-columns: 26% 20% repeat(3, 18%);

    ${props => props.theme.breakpoints.only('lg')} {
      grid-template-columns:
        22% repeat(3, 20%)
        18%;
    }

    ${props => props.theme.breakpoints.down('lg')} {
      display: flex;
    }
  }
`

export const Item = styled(BaseItem)`
  &.calendar__icon {
    .MuiInputBase-root {
      .MuiSvgIcon-root {
        height: 100%;
        padding: 0 6px;
      }

      &.Mui-disabled {
        > div {
          cursor: not-allowed;
          pointer-events: none;
          user-select: none;
        }
      }
    }
  }
`

export const SearchIcon = styled(BaseSearchIcon)`
  &.MuiSvgIcon-root {
    color: ${props => props.theme.palette.brand.white};
    height: 24px;
    margin-right: 8px;
    width: 24px;
  }
`

export const SearchLoadingIcon = styled(props => <BaseSpinner {...props} color="white" size="18px" />)``
